import Class from './c-calendar';
import './c-calendar@';

export default Class;